import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Empty, Tabs } from 'antd';
import _ from 'lodash';
import HeaderBar from 'components/headerBar/header-bar';

const { TabPane } = Tabs;

const Detail = ({
  currentItem, emptyMessage, isEditMode, tabItems, tabPosition, title, defaultKey, onTabChange
}) => {
  const { id } = currentItem;
  // set activeKey
  const [activeKey, setActiveKey] = useState(defaultKey);
  // reset the activeKey if currentItem id object change
  useEffect(() => {
    setActiveKey(!isEditMode ? '0' : defaultKey);
  }, [id]);
  /**
   * @description set the active key and trigger prop callback
   * @param {activeKey} string
   */
  const handleTabChange = (key) => {
    setActiveKey(key);
    onTabChange(key);
  };
  // dispay an emptyMessage if no record is selcted
  if (_.isEmpty(currentItem)) {
    return (
      <div className="bhp-container">
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={emptyMessage}
        />
      </div>
    );
  }
  return (
    <div className="bhp-container">
      <HeaderBar title={`${title} Details`} />
      <div className="bhp-form-container">
        <Tabs tabPosition={tabPosition} activeKey={activeKey} onChange={handleTabChange}>
          {
            tabItems.map(item => (
              item.component && (
                <TabPane forceRender={item.forceRender} key={item.key} tab={item.title} disabled={parseInt(activeKey, 10) !== item.key && !isEditMode}>
                  {item.component}
                </TabPane>
              )
            ))
          }
        </Tabs>
      </div>
    </div>
  );
};

Detail.propTypes = {
  defaultKey: PropTypes.string,
  currentItem: PropTypes.object,
  emptyMessage: PropTypes.string,
  isEditMode: PropTypes.bool,
  onTabChange: PropTypes.func,
  tabItems: PropTypes.array.isRequired,
  tabPosition: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

Detail.defaultProps = {
  defaultKey: '0',
  currentItem: {},
  isEditMode: false,
  emptyMessage: 'Please select a record',
  onTabChange() {
  }
};

export default Detail;
